














































































import { Component, Vue } from "vue-property-decorator";
import qrsModule from "@/store/modules/qrs-module";
import qr_scansModule from "@/store/modules/qr_scans-module";
import { qrs } from "@/shared/dtos/qrs";
import { qr_scans } from "@/shared/dtos/qr_scans";
import { UtilsString } from "@/utils/utils-string";
import { ssmTokenService } from "@/shared/services/token-service";
import { RouterNames } from "@/router/routernames";

@Component({})
export default class qr_scan extends Vue {
  private code: string | null = null;
  private qrInfo: qrs | null = null;
  private qrScans: qr_scans[] | null = null;
  private loading: boolean = true;
  private saving: boolean = false;
  private status: string = "";
  private error: string = "";
  private resultMessage: string = "";

  // device / location fields
  private userAgent: string = navigator.userAgent || "";
  private ip: string = "";
  private country: string = "";
  private region: string = "";
  private city: string = "";
  private lat: number | null = null;
  private lng: number | null = null;
  private isp: string = "";

  // optional user-provided fields
  private name: string = "";
  private email: string = "";

  // scan record tracking
  private scanId: number | null = null;
  private scanToken: string | null = null;
  private autoSent: boolean = false;

  // fecha mínima considerada inválida
  private readonly MIN_VALID_VERIFIED_AT = new Date("1900-01-01T00:00:00Z");

  // Nuevo: devuelve true si hay alguna lectura con nombre y email rellenados
  get hasNameEmail(): boolean {
    if (!this.qrScans || !this.qrScans.length) return false;
    const found = this.qrScans.find(
      (s) =>
        !!s &&
        !!((s as any).name && String((s as any).name).trim().length > 0) &&
        !!((s as any).email && String((s as any).email).trim().length > 0)
    );
    if (found) {
      // Si aún no tenemos name/email en el componente, rellenarlos desde la primera lectura válida
      if (!this.name && (found as any).name)
        this.name = String((found as any).name);
      if (!this.email && (found as any).email)
        this.email = String((found as any).email);
      return true;
    }
    return false;
  }

  // Nuevo: devuelve true si alguna lectura tiene verified_at mayor que MIN_VALID_VERIFIED_AT
  get verifiedByDate(): boolean {
    if (!this.qrScans || !this.qrScans.length) return false;
    return this.qrScans.some((s) => {
      const v = (s as any).verified_at;
      if (!v) return false;
      const d = new Date(v);
      return d > this.MIN_VALID_VERIFIED_AT;
    });
  }

  // utilidad para mostrar la fecha de verified_at de forma legible
  private formatVerifiedAt(val: any): string {
    if (!val) return "-";
    const d = new Date(val);
    if (isNaN(d.getTime())) return String(val);
    if (d <= this.MIN_VALID_VERIFIED_AT) return "-";
    return d.toLocaleString();
  }

  async mounted() {
    await this.init();
    if (ssmTokenService.hasToken()) {
      const go = confirm("¿Desea ir al listado de códigos QR?");
      if (go) {
        this.$router.push({
          name: RouterNames.listado_qrs,
          query: { code: this.code },
        });
      }
    }
  }

  private async init() {
    try {
      this.loading = true;
      this.status = "Leyendo código de la URL";
      const fromQuery =
        (this.$route && (this.$route.query as any).code) ||
        (this.$route && (this.$route.params as any).code);
      this.code = (fromQuery as string) || null;
      if (!this.code) {
        this.error = "No se encontró el código en la URL (param 'code').";
        this.loading = false;
        return;
      }

      // obtener info del QR desde el módulo/store si existe método
      this.status = "Obteniendo datos del QR";

      try {
        this.qrInfo = await qrsModule.getqrsCode(this.code);
        if (!this.qrInfo) {
          this.error = "Código QR no encontrado.";
        } else {
          this.error = "";
          this.qrScans = await qr_scansModule.getqrsCode(this.code);
        }
      } catch (e) {
        console.warn("qrsModule.getqrsCode fallo:", e);
      }

      // intentar obtener geolocalización del navegador (si el usuario lo permite)
      this.status = "Obteniendo geolocalización";
      await this.getGeolocation();

      // obtener IP / ISP / location desde servicio externo (ipapi.co)
      this.status = "Obteniendo datos de IP/ISP";
      await this.getIpInfo();

      this.status = "Listo";

      // una vez tengamos los metadatos intentamos enviar automáticamente
      // (no requiere nombre/email)
      await this.tryAutoSend();
    } catch (err) {
      console.error(err);
      this.error = String(err);
    } finally {
      this.loading = false;
    }
  }

  private getGeolocation(): Promise<void> {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        return resolve();
      }
      const timeout = setTimeout(() => {
        resolve();
      }, 5000);
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          clearTimeout(timeout);
          this.lat = pos.coords.latitude;
          this.lng = pos.coords.longitude;
          resolve();
        },
        () => {
          clearTimeout(timeout);
          resolve();
        },
        { maximumAge: 60000, timeout: 5000 }
      );
    });
  }

  private async getIpInfo() {
    try {
      const res = await fetch("https://ipapi.co/json/");
      if (!res.ok) return;
      const j = await res.json();
      this.ip = j.ip || this.ip;
      this.country = j.country_name || this.country;
      this.region = j.region || this.region;
      this.city = j.city || this.city;
      if (j.latitude && j.longitude) {
        this.lat = this.lat || Number(j.latitude);
        this.lng = this.lng || Number(j.longitude);
      } else if (j.loc) {
        const [la, lo] = String(j.loc).split(",");
        this.lat = this.lat || Number(la);
        this.lng = this.lng || Number(lo);
      }
      this.isp = j.org || this.isp || j.org;
    } catch (err) {
      console.warn("No se pudo obtener IP info:", err);
    }
  }

  private generateToken(len = 64) {
    const bytes = new Uint8Array(len / 2);
    if (
      typeof window !== "undefined" &&
      (window.crypto as any) &&
      (window.crypto as any).getRandomValues
    ) {
      (window.crypto as any).getRandomValues(bytes);
    } else {
      for (let i = 0; i < bytes.length; i++)
        bytes[i] = Math.floor(Math.random() * 256);
    }
    return Array.from(bytes)
      .map((b) => ("0" + b.toString(16)).slice(-2))
      .join("")
      .slice(0, len);
  }

  private buildPayload(includeNameEmail = true): Partial<qr_scans> {
    const payload: qr_scans = new qr_scans({
      qr_id: (this.qrInfo && (this.qrInfo as any).id) || null,
      name: UtilsString.ValueOf(this.name || null),
      email: UtilsString.ValueOf(this.email || null),
      verification_token: this.generateToken(64),
      verified_at:
        this.qrInfo && (this.qrInfo as any).redeemed_at
          ? new Date(this.qrInfo.redeemed_at)
          : new Date("1900-01-01T00:00:00Z"),
      ip: this.ip || null,
      user_agent: this.userAgent || null,
      device_info: navigator.platform || null,
      country: this.country || null,
      region: this.region || null,
      city: this.city || null,
      lat: this.lat !== null ? Number(this.lat.toFixed(7)) : null,
      lng: this.lng !== null ? Number(this.lng.toFixed(7)) : null,
      isp: this.isp || null,
    });
    return payload;
  }

  private async tryAutoSend() {
    // don't auto send if already have a scan
    if (this.scanId) return;
    // require at least ip or lat/lng or userAgent to be present
    const haveMeta =
      !!this.ip || (!!this.lat && !!this.lng) || !!this.userAgent;
    if (!haveMeta) return;
    // auto send (no name/email)
    await this.sendScan(true);
  }

  // canUpdate: indicates whether we can update name/email to an existing scan
  get canUpdate() {
    return !!this.scanId;
  }

  private async sendScan(auto = false) {
    // auto=true => creation without name/email
    // manual click: if scanId exists, we perform update with name/email; else create including name/email
    try {
      this.saving = true;
      this.resultMessage = "";

      if (!this.scanId) {
        // Create new scan (auto or manual)
        const payloadObj = this.buildPayload(!auto);
        const scanToCreate = new qr_scans(payloadObj);
        console.log("Creating scan:", scanToCreate);

        // call module action to save
        const created = await qr_scansModule.guardarqr_scans(scanToCreate);

        // guardar id/token si el backend devuelve
        if (created) {
          if ((created as any).id) this.scanId = (created as any).id;
          if ((created as any).verification_token)
            this.scanToken = (created as any).verification_token;

          if (!auto) {
            alert(
              "Scan registrado correctamente. Revise su email para verificarlo."
            );

            this.qrScans = await qr_scansModule.getqrsCode(this.code!);
          }
        }

        this.autoSent = !!auto;
        this.resultMessage = auto
          ? "Scan enviado automáticamente."
          : "Scan registrado correctamente.";
      } else {
        qr_scansModule.getqr_scans(this.scanId).then(async (existingScan) => {
          if (existingScan) {
            existingScan.name = this.name || null;
            existingScan.email = this.email || null;

            await qr_scansModule.modificarqr_scans(existingScan);
          }
        });

        this.resultMessage = "Nombre/email actualizados correctamente.";
      }
    } catch (err) {
      console.error("Error registrando scan:", err);
      this.resultMessage = `Error registrando scan: ${
        err && (err as Error).message ? (err as Error).message : String(err)
      }`;
    } finally {
      this.saving = false;
    }
  }

  private retry() {
    this.sendScan(true);
    this.error = "";
    this.resultMessage = "";
    this.init();
  }
}
